import React from "react";
import { WithSearch } from "@elastic/react-search-ui";

// show num of displayed results [out of] num of total results
export default function CustomPagingInfo() {
  return (
    <WithSearch
      mapContextToProps={({ totalResults, current, resultsPerPage }) => ({
        totalResults,
        current,
        resultsPerPage,
      })}
    >
      {({ totalResults, current, resultsPerPage }) => {
        const start = totalResults === 0 ? 0 : (current - 1) * resultsPerPage + 1;
        const end = start + resultsPerPage - 1 > totalResults ? totalResults : start + resultsPerPage - 1;
        return (
          <span id="results-displayed">
            מציג {start} - {end} מתוך {totalResults} תוצאות
          </span>
        );
      }}
    </WithSearch>
  );
}